module.exports = __webpack_public_path__ + "images/mobile/arrow-line-c350321888d7f94d37c6f084084a83df.png";